'use strict';

import AdminService from './AdminService';
import StatusService from './StatusService';
import DataSummaryService from './DataSummaryService';
import ClientService from "./ClientService";
import CookieService from "./CookieService";
import ConfigurationService from './ConfigurationService';

export var adminService = new AdminService();
export var statusService = new StatusService();
export var dataSummaryService = new DataSummaryService();
export var clientService = new ClientService();
export var cookieService = new CookieService();
export var configurationService = new ConfigurationService();